import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("jastip_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response && err.response.status === 401) {
      localStorage.removeItem("jastip_token");
      localStorage.removeItem("jastip_user");
      if (!window.location.pathname.startsWith("/login") && !window.location.pathname.startsWith("/katalog")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
